import { Route, Routes } from 'react-router-dom'
import * as React from 'react'
import StudySelect from '../../../Pages/Study/StudySelect/StudySelect'
import SelectedStudyModule from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import Protocols from '../../../Pages/Study/Protocols/Protocols'
import SelectedStudyRouter from './SelectedStudyRouter'

function StudyRouter() {
  return (
    <Routes>
      <Route
        index
        element={<StudySelect />}
      />
      <Route
        path="protocols"
        element={<Protocols />}
      />
      <Route
        path=":study_id/*"
        element={
          <SelectedStudyModule>
            <SelectedStudyRouter />
          </SelectedStudyModule>
        }
      />
    </Routes>
  )
}

export default StudyRouter
